import { Box, Button, Fade, Paper, Stack, useTheme } from '@mui/material';
import { Md } from '@next-box/i18n/client';
import { Link } from '#components/Link/index.tsx';
import { tt } from '#i18n/index.ts';
import { useStore } from '#store/useStore.ts';

export const CookieConsent = () => {
  const theme = useTheme();
  const additionalCookiesAccepted = useStore(store => store.additionalCookiesAccepted);
  const setAdditionalCookiesAccepted = useStore(store => store.setAdditionalCookiesAccepted);

  return (
    <Fade appear={true} in={additionalCookiesAccepted === undefined}>
      <Paper
        aria-label="Cookie banner"
        aria-modal="false"
        role="dialog"
        square
        sx={{
          borderColor: theme.palette.divider,
          borderTopWidth: 1,
          bottom: 0,
          left: 0,
          margin: 0,
          paddingX: theme.spacing(3),
          paddingY: theme.spacing(2),
          position: 'fixed',
          right: 0,
          [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(2),
          },
        }}
        tabIndex={-1}
        variant="outlined"
      >
        <Stack direction={{ sm: 'row', xs: 'column' }} sx={{ gap: 2, justifyContent: 'space-between' }}>
          <Box sx={{ ['& p']: { marginBottom: 0 }, alignSelf: { sm: 'center', xs: 'flex-start' }, flexShrink: 1 }}>
            <Md>{tt('cookieConsent.content')}</Md>
          </Box>
          <Stack
            direction="row"
            sx={{
              alignSelf: { sm: 'center', xs: 'flex-end' },
              flexShrink: 0,
              gap: 2,
            }}
          >
            <Button
              onClick={() => {
                setAdditionalCookiesAccepted(true);
              }}
              size="small"
              variant="contained"
            >
              {tt('cookieConsent.acceptButton')}
            </Button>
            <Button component={Link} href="/cookie-settings" size="small">
              {tt('cookieConsent.customiseButton')}
            </Button>
          </Stack>
        </Stack>
      </Paper>
    </Fade>
  );
};
